import { createContext, useContext } from 'react'
import * as stores from '../'

const StoresContext = createContext({ ...stores })
const useStores = () => {
  return useContext(StoresContext)
}
export default useStores
